export const utilsConstants = {
    REQUEST_COUNTRY: 'REQUEST_COUNTRY',
    RECIEVE_COUNTRY: 'RECIEVE_COUNTRY',
    ERROR_COUNTRY: 'ERROR_COUNTRTY',
};
